
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'CommentIcon',
})
export default class CommentIcon extends Vue {

}
